import React, { useState } from "react";
import { snakeCase } from "lodash";
import RlNavigationDropdownItem from "./components/RlNavigationDropdownItem";
import { getHelpDropdownItems } from "../utils";
import MethodologyPopup from "../../../components/MethodologyPopup";
import RlNavigationSubmenuItem from "./components/RlNavigationSubmenuItem";

const RlNavigationHelpItem = () => {
  const [show, setShow] = useState(false);
  const helpItems = getHelpDropdownItems();

  return (
    <>
      <RlNavigationDropdownItem
        className="menu-help"
        title="Help"
        openOnHover
        showCaret
        id={"help"}
      >
        {helpItems.map(item => {
          const { label, ...rest } = item;
          return (
            <RlNavigationSubmenuItem
              key={label}
              testId={snakeCase(`main_nav_menu_item_${label}`)}
            >
              <a {...rest}>{label}</a>
            </RlNavigationSubmenuItem>
          );
        })}
        <RlNavigationSubmenuItem testId="main_nav_menu_item_methodology_popup">
          <span onClick={() => setShow(true)} className="main-nav__item-link">
            Methodology / Legend
          </span>
        </RlNavigationSubmenuItem>
      </RlNavigationDropdownItem>
      {show && <MethodologyPopup open={show} onClose={setShow} />}
    </>
  );
};

export default RlNavigationHelpItem;
